// eslint-disable-next-line import/no-anonymous-default-export
export default {
  meEndpoint: '/auth/me',
  loginEndpoint: '/jwt/login',
  registerEndpoint: '/jwt/register',
  storageTokenKeyName: 'ask-milo-landing-page-accessToken',
  storageUserDataKeyName: 'ask-milo-landing-page-userData',
}
